module.exports = __webpack_public_path__ + "order/img/paw_card.c79a03a8.png";